import type { CommentData } from '@liveblocks/client'

import { commentBodyToPlainText } from '@/components/shared/comment/utils'

import type { CommentFilter } from './types'

// Mentions are stored as the mentioned user's email, so searching "hen" still finds "@Hen Nassimy".
export const threadMatchesSearch = (comments: readonly CommentData[], search: string): boolean => {
  const query = search.trim().toLowerCase()
  if (!query) return true
  return comments.some((comment) =>
    commentBodyToPlainText(comment.body).toLowerCase().includes(query),
  )
}

export const threadMatchesFilter = (
  comments: readonly CommentData[],
  filter: CommentFilter,
  currentUserId?: string,
): boolean => {
  if (filter === 'all') return true
  return !!currentUserId && comments.some((comment) => comment.userId === currentUserId)
}
